<template>
    <b-card :title="title">
        <!-- Details Dialog -->
        <export-details-dialog :query-data="queryModel" ref="detailsDialog" />
        <b-card-header>
            <b-row>
                <b-col>
                    <b-form-input type="search" :placeholder="crm ? 'Search Tasks...' : 'Search Assets...'
                        " v-model="query"></b-form-input>
                </b-col>

                <b-col cols="3">
                    <b-button variant="light" v-if="hasPermissionView" @click="toggle_filters = !toggle_filters">
                        Filters
                        <b-icon :icon="'chevron-' + (toggle_filters ? 'up' : 'down')
                            " variant="dark"></b-icon>
                    </b-button>

                    <b-button variant="light" size="sm" @click="resetFilters" v-b-tooltip.hover title="Reset Filters">
                        <b-icon icon="arrow-repeat" variant="dark"></b-icon>
                    </b-button>
                </b-col>

                <b-col class="text-right">
                    <slot></slot>
                </b-col>
            </b-row>

            <asset-query-builder v-show="toggle_filters" v-model="filters" :types="types" :crm="crm" :officers="officers"
                :roles="roles" :crm-setting-value="crmSettingValue" />
        </b-card-header>
        <b-card-body>
            <p class="mt-3">
                Page: {{ pagination.page }} of {{ pageCount }} Total:
                {{ pagination.total }}
            </p>
            <b-table :fields="assetFields" striped hover responsive :items="items" :busy="loading">
                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                </template>
                <template #cell(id)="row">
                    <b-button size="sm" v-if="hasPermissionView" @click="viewAsset(row.item.id)" class="mr-2"
                        variant="primary">
                        View
                    </b-button>
                </template>

                <template #cell(frequency)="{ value }">
                    <span>{{ getFrequencyType(value) }}</span>
                </template>
            </b-table>
            <b-row>
                <b-col>
                    <b-pagination class="float-right" v-model="pagination.page" :total-rows="pagination.total"
                        :per-page="pagination.pageSize" aria-controls="assetTable" pills align="right"></b-pagination>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>

<script>
import _ from 'lodash'
import popupMixins from '@/mixins/popupMixins'
import AssetQueryBuilder from './AssetQueryBuilder'
import ExportDetailsDialog from './ExportDetailsDialog'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'assets-itemList',
    components: { AssetQueryBuilder, ExportDetailsDialog },
    props: [
        'type',
        'items',
        'title',
        'crm',
        'crmSettingValue',
        'officers',
        'roles',
        'types',
    ],
    mixins: [popupMixins, permissionsMixins],
    data() {
        return {
            query: '',
            toggle_filters: false,
            loading: false,
            filters: {
                customer_id: null,
                type_id: null,
                default_engineer_id: null,
                role_id: null,
                next_service_from: null,
                next_service_to: null,
                last_service_from: null,
                last_service_to: null,
                warranty_from: null,
                warranty_to: null,
            },
        }
    },

    mounted() {
        console.log('items', this.items)
        if (this.$route.query.query) this.query = this.$route.query.query
        this.doSearch()
    },
    computed: {
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize)
        },
        pagination() {
            return this.$store.state.assets.assets_pagination
        },
        user() {
            return this.$store.state.user
        },


        queryModel() {
            const { query } = this
            return { query, ...this.filters }
        },
        assetFields() {
            const { crm } = this

            const commonFields = [
                {
                    key: 'id',
                    label: '',
                    stickyColumn: true,
                },
                'name',
                {
                    key: 'location_section_id',
                    label: 'Location',
                    formatter: (value, key, item) =>
                        (x => x.name + ', ' + x.location.address1)(
                            item.location_section
                        ),
                },

                {
                    key: 'customer_id',
                    label: 'Customer',
                    formatter: (value, key, item) => item.customer.name,
                },

                'frequency',
                {
                    key: 'last_service_date',
                    label: crm ? 'Last Visit' : 'Last Service',
                },
                {
                    key: 'next_service_date',
                    label: crm ? 'Next Visit' : 'Next Service',
                },
                {
                    key: 'default_engineer',
                    label: 'Agent',
                    formatter: value =>
                        value ? value.first_name + ' ' + value.last_name : '',
                },
            ]

            if (crm) return commonFields
            else
                return [
                    ...commonFields,
                    'model_no',
                    'serial_no',
                    {
                        key: 'type_id',
                        label: 'Type',
                        formatter: (value, key, item) => item.type.name,
                    },
                    { key: 'warranty_expiry_date', label: 'Warranty' },
                    { key: 'contract_expiry_date', label: 'Contract' },
                ]
        },
    },

    watch: {
        'crmSettingValue.type_id': function (type_id) {
            if (this.crm) this.$set(this.filters, 'type_id', type_id || null)
        },
        'pagination.page': function (newPage) {
            this.changePage(newPage)
        },
        filters: {
            handler: function () {
                this.doSearch()
            },
            deep: true,
        },
        query: function (query) {
            this.$router.push({ query: { query } })
            this.doSearch()
        },
    },

    methods: {
        getSearchQuery() {
            const { query, filters } = this
            return { query, ...filters }
        },
        viewAsset(id) {
            const path = `${this.$route.path}/${id}`
            this.$router.push({ path })
        },

        resetFilters() {
            this.filters = {
                customer_id: null,
                type_id: null,
                default_engineer_id: null,
                role_id: null,
                next_service_from: null,
                next_service_to: null,
                last_service_from: null,
                last_service_to: null,
                warranty_from: null,
                warranty_to: null
            };
            this.doSearch();
        },
        changePage(page) {
            this.$router.push({ query: { page } })
            this.doSearch()
        },
        doSearch: _.debounce(async function () {
            await this.pureSearch()
        }, 500),
        async pureSearch(doReset) {
            try {
                this.loading = true
                const {
                    query,
                    pagination: { page },
                    filters,
                    crm,
                    crmSettingValue: { type_id },
                } = this

                if (crm) {
                    this.$set(filters, 'type_id', type_id || null)
                    this.$set(filters, 'warranty_from', null)
                    this.$set(filters, 'warranty_to', null)
                } else if (doReset) {
                    this.$set(filters, 'type_id', null)
                }

                this.$set(filters, 'crm_type_id', type_id || null)

                await this.$store.dispatch('assets/fetch', {
                    query,
                    page,
                    filters,
                })
            } catch (err) {
                console.error('loading error', err)
            } finally {
                this.loading = false
            }
        },
        showDetailsDialog() {
            this.$refs.detailsDialog.show(this.queryModel)
        },
        getFrequencyType(value) {
            const { frequencies } =
                this.$store.getters['company/assetFrequencies']
            const obj = (frequencies || []).find(x => x.value == value)
            return obj ? obj.name : value == '0' ? 'One Off' : ''
        },
    },
}
</script>
<style></style>
